import React from 'react';
import { TbClipboardList, TbMapPin, TbInfoCircle, TbChevronRight } from "react-icons/tb";

const InfoStep = ({ locationInfo, onBack, onConfirm }) => {
  return (
    <div className="step-content_">
      <h2 className="step-title">Información Importante</h2>

      <div className="info-cards">
        <div className="info-card card_background">
          <div
            style={{
              display: "flex",
              justifyContent: "start",
              gap: ".5rem",
              alignItems: "center",
            }}
          >
            <div className="info-icon_">
              <TbClipboardList />
            </div>
            <h3 style={{ fontSize: "1.3rem" }}>Preparación para la cita</h3>
          </div>
          <ul className="small-text">
            <li>Lleva tu documento de identificación</li>
            <li>Trae tu carné de la EPS o seguro médico</li>
            <li>Llega 15 minutos antes de tu cita</li>
            <li>Trae exámenes anteriores si los tienes</li>
            <li>Evita usar perfumes o colonias fuertes</li>
            <li>Trae lista de medicamentos que tomas actualmente</li>
          </ul>
        </div>

        <div className="info-card card_background">
          <div
            style={{
              display: "flex",
              justifyContent: "start",
              gap: ".5rem",
              alignItems: "center",
            }}
          >
            <div className="info-icon_">
              <TbMapPin />
            </div>
            <h3 style={{ fontSize: "1.3rem" }}>Ubicación y Acceso</h3>
          </div>
          <div className="small-text">
            <p>
              <strong>Dirección:</strong> {locationInfo.location}
            </p>
            <p>
              <strong>Horario:</strong> {locationInfo.hours}
            </p>
            <p>
              <strong>Teléfono:</strong> {locationInfo.phone}
            </p>
            <p>
              <strong>Parking:</strong> Disponible en el sótano del edificio
            </p>
          </div>
        </div>

        <div className="info-card card_background">
          <div
            style={{
              display: "flex",
              justifyContent: "start",
              gap: ".5rem",
              alignItems: "center",
            }}
          >
            <div className="info-icon_">
              <TbInfoCircle />
            </div>
            <h3 style={{ fontSize: "1.3rem" }}>Políticas de Cancelación</h3>
          </div>
          <ul className="small-text">
            <li>
              Cancelaciones con menos de 24 horas tendrán un cargo del 30%
            </li>
            <li>Si no asistes a tu cita sin previo aviso, se cobrará el 50%</li>
            <li>Para reprogramaciones, comunícate al menos 48 horas antes</li>
          </ul>
        </div>
      </div>

      <div className="form-actions">
        <button className="back-btn" onClick={onBack}>
          Volver
        </button>
        <button className="confirm-btn" onClick={onConfirm}>
          <span>Siguiente</span>
          <span style={{ marginRight: "-.5rem" }}>
            <TbChevronRight size={21} />
          </span>
        </button>
      </div>
    </div>
  );
};

export default InfoStep;